import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//PAGES
import { ListaGestorPage } from '../listaGestor/listaGestor';
import { OperadorPedidosPage } from '../operador-pedidos/operador-pedidos';
import { AdiantadorPedidosPage } from '../adiantador-pedidos/adiantador-pedidos';
import { EntregasPage } from '../entregas/entregas';

//PROVIDERS
import { Tools, User, Services } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-changepass',
  templateUrl: 'changepass.html',
})
export class ChangepassPage {
  account: { username: string, password: string, repassword: string} = {
    username: '',
    password: '',
    repassword: '',
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private user: User,
    private tools: Tools,
    private services: Services
  ) {
  }

  ionViewDidLoad() {
    let user = this.user.getUser();
    console.log(user);
    this.account.username = user.username+'';
  }

  salvar(){
    if(this.account.password.length<4){
      this.tools.showAlert('toast','A senha deve conter no mínimo 4 caracteres.');
      return
    }

    if(this.account.password != this.account.repassword){
      this.tools.showAlert('toast','As senhas não coincidem.');
      return
    }

    let user = this.user.getUser();
    let base = 'cadUsuarios';
    if(user.motorista){
      base = 'cadMotoristas';
    }
    if(user.operador){
      base = 'cadOperadores';
    }

    let loading = this.tools.showLoading('Carregando...');
    loading.present();
    user.password = this.account.password+'';
    user.changePass = true;
    this.services.save(base,user,(result)=>{
      this.tools.showAlert('toast','Senha alterada com sucesso.');
      if(user.motorista){
        this.navCtrl.setRoot(ListaGestorPage);
      }else if(user.operador){
        if(user.adiantador){
          this.navCtrl.setRoot(AdiantadorPedidosPage,{item:loading});
        }else{
          this.navCtrl.setRoot(OperadorPedidosPage,{item:loading});
        }
      }else{
        this.navCtrl.setRoot(ListaGestorPage);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/changepass/changepass.ts